import { useCallback } from 'react';
export function useHandleCreateAI() {
    return useCallback(() => {
        window.dispatchEvent(new Event('app-content-admin:contentlist:ai'));
    }, []);
}
